import { ButtonKeys, loadSeahorseDataShared, setupBlockUIDefaults } from '../common/common';
import { Utils } from '../common/fancybox';

const fancyboxUtils = Utils.getInstance();

export function init(): void {
  $(() => {
    const fancyIframe = parent.$ && parent.$('iframe#fancybox-frame');
    if (fancyIframe && fancyIframe.length > 0) {
      fancyboxUtils.iFrameReloadResize();
    }

    const fancyBoxClose = parent.$ && parent.$('#fancybox-close');
    if (typeof fancyBoxClose != 'undefined' && fancyBoxClose.length > 0) {
      fancyBoxClose.show();
    }
  });
}

export function cancelFancyModal(): void {
  fancyboxUtils.HideFancyModal(false);
}

export function ShowProcessing(): void {
  const loadingMessage = $('#loading-message, #progress-container');

  if (loadingMessage == null || loadingMessage.length == 0) {
    return;
  }

  if (window.shouldShowProcessing !== undefined && !window.shouldShowProcessing) {
    return;
  }

  const fancyBoxClose = parent.$('#fancybox-close');
  if (typeof fancyBoxClose != 'undefined' && fancyBoxClose.length > 0) {
    fancyBoxClose.hide();
  }

  const dialogHold = $('#dialogHold');
  if (dialogHold.parent().hasClass('brandingDiv')) {
    dialogHold.parent().hide();
  } else {
    dialogHold.hide();
  }

  loadingMessage.show();

  const panel = $('#panelModalMain, .fancyModalBox');

  if (panel.length) {
    // For newer "panel modal" based dialogs where the layout works slightly differently.
    fancyboxUtils.resize('body');
  }
}

export class GridData implements JqGrid.Data {
  page: number;
  rows: { id: string; cell: string[] }[];
  total: number;
  records: number;

  constructor() {
    this.page = 1;
    this.rows = [];
    this.total = 0;
    this.records = 0;
  }
}

export function filterGrid(
  originalArray: GridData,
  grepFunction: (row: { id: string; cell: string[] }, index: number) => boolean,
): GridData {
  const filteredRows = $.grep(originalArray.rows, grepFunction);

  return {
    page: originalArray.page,
    rows: filteredRows,
    total: filteredRows.length,
    records: filteredRows.length,
  };
}

export function configureServiceProviderGrid(
  id: string,
  url: string | undefined,
  onlySingleSelect: boolean,
  mainColumnWidth: number,
  searchBoxId: string,
  searchLinkId: string,
  existingData: { ServiceProviderName: string; Identifier: { Value: string } }[],
): void {
  let allSPs: GridData | null = null;
  setupBlockUIDefaults();
  $('.serviceProviderGridHold').block({ message: '<span>' + UiText.t('Shared_Loading_Text') + '</span>' });

  const searchFunction = function () {
    if (!allSPs) {
      throw new Error('SP data not initialized');
    }

    const searchText = ($('#' + searchBoxId).val() as string).toLowerCase();

    const searchResults = filterGrid(allSPs, function (row) {
      for (let i = 0; i < row.cell.length; i++) {
        // html decodes the text for comparison.
        const text = $('<div></div>').html(row.cell[i].toLowerCase()).text();
        if (text.indexOf(searchText) != -1) {
          return true;
        }
      }
      return false;
    });
    loadServiceProviderData(id, searchResults, allSPs);
  };

  $('#' + searchLinkId).click(searchFunction);
  $('#' + searchBoxId).keyup(function (event) {
    if (event.keyCode == ButtonKeys.EnterKey) {
      searchFunction();
    }
  });

  const grid = $('#' + id);
  grid.jqGrid({
    altRows: true,
    datatype: 'local',
    colNames: ['Service Providers'],
    colModel: [
      {
        name: 'ServiceProviderName',
        index: 'serviceProviderName',
        width: mainColumnWidth,
        align: 'left',
        cellattr: (_: unknown, tv: string) => 'style="white-space: normal;padding-right:20px;" title="' + tv + '"',
        sortable: false,
      },
    ],
    height: 300,
    scrollOffset: 0,
    cellLayout: onlySingleSelect ? 6 : 11.1,
    multiselect: !onlySingleSelect,
    rowNum: Number.MAX_SAFE_INTEGER, // Display all the records
    scroll: true,
    shrinkToFit: true,
    forceFit: true,
    gridview: true,
    viewsortcols: [false, 'vertical', true],
    onSelectRow: function (rowid: string) {
      let event;
      if (onlySingleSelect) {
        event = $.Event('seahorse.serviceProviderRowSelected.single');
        event.rowid = rowid;
      } else {
        event = $.Event('seahorse.serviceProviderRowSelected.multi');
        event.rowids = (grid.getGridParam('selarrrow') as string[]).slice();
      }
      $('#' + id).trigger(event);
    },
    onSelectAll: function () {
      const event = $.Event('seahorse.serviceProviderRowSelected.multi');
      event.rowids = (grid.getGridParam('selarrrow') as string[]).slice();
      $('#' + id).trigger(event);
    },
    ondblClickRow: function (rowid: string) {
      const event = $.Event('seahorse.serviceProviderRowDoubleClicked');
      event.rowid = rowid;
      $('#' + id).trigger(event);
    },
  });

  // Gets the data from the server (if required)
  if (url) {
    $.post(url, function (data) {
      allSPs = new GridData();
      generateAllSPs(id, allSPs, data.Result);
    });
  } else if (existingData != null) {
    allSPs = new GridData();
    generateAllSPs(id, allSPs, existingData);
  } else {
    throw 'Should have either a url or existing data';
  }
  $('#' + id).on(
    'seahorse.serviceProviderRefreshGrid' as never,
    function (event: { rowData: GridData; clearSearch: unknown; rowDataToRemove: unknown[] }) {
      allSPs = event.rowData;

      if (event.clearSearch != null) {
        $('#' + searchBoxId).val('');
        loadServiceProviderData(id, allSPs, allSPs);
      } else if (event.rowDataToRemove != null) {
        for (let i = 0; i < event.rowDataToRemove.length; i++) {
          if (!$('#' + id).delRowData(event.rowDataToRemove[i])) {
            throw 'Failed to delete row';
          }
        }

        triggerGridLoadedEvent(id, allSPs);
      } else {
        throw 'Should be able to add or remove row data.';
      }
    },
  );
}

function loadServiceProviderData(id: string, data: GridData, allData: GridData) {
  data.rows = data.rows.sort(function (a, b) {
    if (a.cell[0].toLowerCase() == b.cell[0].toLowerCase()) {
      return 0;
    }
    return a.cell[0].toLowerCase() > b.cell[0].toLowerCase() ? 1 : -1;
  });
  loadSeahorseDataShared(id, data);

  triggerGridLoadedEvent(id, allData);
}

function triggerGridLoadedEvent(id: string, allData: GridData) {
  const event = $.Event('seahorse.serviceProviderGridLoaded');
  event.rowData = allData;
  $('#' + id).trigger(event);
}

function generateAllSPs(id: string, allSPs: GridData, result: { ServiceProviderName: string; Identifier: { Value: string } }[]) {
  allSPs.total = result.length;
  allSPs.records = result.length;
  allSPs.page = 1;
  allSPs.rows = [];
  for (let i = 0; i < result.length; i++) {
    const row = result[i];
    const rowObj = {
      id: row.Identifier.Value,
      cell: [row.ServiceProviderName],
    };
    allSPs.rows.push(rowObj);
  }

  loadServiceProviderData(id, allSPs, allSPs);
  $('.serviceProviderGridHold').unblock();
}
